<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" width="80%">
            <div>
                <div v-if="showcargando == true" id="cargando" wire:loading
                    class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
                    <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
                    <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
                    <p class="w-1/3 text-center text-white">
                        Esto puede tardar unos segundos, no cierre esta página.
                    </p>
                </div>
                <v-card flat class="text-xs-center">
                    <v-divider></v-divider>
                    <p></p>
                    <p></p>
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Movimientos Reporte: {{ datos.nrreporte }}-{{ datos.svindice
                        }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn color="red accent-3" icon text @click="emitDialogClose()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text>

                        <v-row v-if="this.mostrarAlert == true">


                            <v-alert dense border="left" type="warning"
                                style="align-self: center; margin: 15px; width: 100%; padding: 15px">
                                <strong>Reporte Archivado</strong>
                                <p>
                                    No es posible visualizar la información,contacte a desarrollo.
                                </p>
                            </v-alert>

                        </v-row>
                        <v-row v-if="this.mostrarAlert == false">

                            <v-col cols="12" md="6" v-if="ci">
                                <v-switch v-model="switchci" label="Mostrar movimientos con CI" inset
                                    @change="movimientossinCI()">
                                </v-switch>
                            </v-col>
                            <v-col cols="12" md="12" v-if="abrir">
                                <DataTable :url="urlListado" :columns="columns" :params="displayInputs"
                                    :order="[[0, 'desc']]" @apiDT="apiDT = $event" :movil="isMovil"
                                    @Cancelar="CancelarShow"></DataTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

            </div>
        </v-dialog>
    </v-row>
</template>
<script>

import { mapActions, mapState } from 'vuex';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import DataTable from "@/components/pages/DataTableNet/DataTable";
import General from '@/services/ReporteGeneral/ReporteGeneral.service.js';

export default {
    name: "Expediente",
    components: {
        DataTable
    },
    props: ["exnrreporte",
        "exsvindice", "exaiclave"]

    ,
    data: function () {
        return {
            dialog: true,
            apiDT: null,
            abrir: false,
            showcargando: true,
            listado: [],
            aiclave: '',
            veTabla: false,
            veEdita: false,
            veElimina: false,
            vivr: false,
            perfil: '',
            switchci: true,
            ultVisita: [],
            /////////////////////////////////////////////////////////////////////////
            urlListado: "Movimientos/ObtenerMovimientos",
            columns: [
                { name: 'Esid', data: 'Esid', title: "T.P.", formatter: [this, "tpreporte"], orderable: false },
                { name: 'Exfechas', data: 'Exfechas', title: "Fecha" },
                { name: 'Exfechaabo', data: 'Exfechaabo', title: "Fecha Abo" },
                { name: 'Cegrupo', data: 'Cegrupo', title: "Tipo" },
                { name: 'Ceconcepto', data: 'Ceconcepto', title: "Concepto" },
                { name: 'Exresp', data: 'Exresp', title: "Resp" },
                { name: 'Exobs', data: 'Exobs', title: "Observaciones" },
                { name: 'Uslogin', data: 'Uslogin', title: "Usuario" },

            ],

            isMovil: true,
            ci: true,
            mostrarAlert: false,
            asistenciaurl: '',
            primerElemento: null,
            datos: {
                nrreporte: 0,
                svindice: 0,
                aiclave: 0
            }
        };
    },
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        }
    },

    methods: {
        emitDialogClose() {
            this.$emit("dialogCloseEvent", false);
        },
        CancelarShow() {
            this.showcargando = false;
        },
        async movimientossinCI() {
            this.showcargando = true;
            this.displayInputs = {
                nrreporte: this.datos.nrreporte,
                svindice: this.datos.svindice,
                CI: this.switchci,
                uslogin: MetodosGenerales.ObtenerUserName(),
                aiclave: this.datos.aiclave
            };

        },

        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },

        tpreporte(datos) {
            return datos.Esid == 7 ? `<i aria-hidden="true" class="v-icon notranslate mdi mdi-lock-open-variant theme--light success--text"></i>` : `<i aria-hidden="true" class="v-icon notranslate mdi mdi-lock-open theme--light error--text"></i>`;
        },



        addRowClass() {
            const elements = document.querySelectorAll('.checkedEl');
            elements.forEach(element => {
                if (element.parentNode) {
                    element.parentNode.classList.add('markedrow');
                }
            });
        },

    },
    watch: {
        'dialog'(val) {
            if (val == false) {
                this.$emit("dialogCloseEvent", false);
            }
        }
    },

    async mounted() {

        this.datos.nrreporte = parseInt(this.exnrreporte); //;
        this.datos.svindice = parseInt(this.exsvindice);//;
        this.datos.aiclave = parseInt(this.exaiclave);

        this.displayInputs = {
            nrreporte: this.datos.nrreporte,
            svindice: this.datos.svindice,
            CI: true,
            uslogin: MetodosGenerales.ObtenerUserName(),
            aiclave: this.datos.aiclave
        };
        this.abrir = true;

        var deshabilitado = await General.VerificarReporte(this.datos);

        if (deshabilitado == 1) {
            this.mostrarAlert = true;
            this.showcargando = false;
        }

    }
}
</script>


<style scoped>
.help-dialog-style {
    width: 70% !important;
    min-width: 340px !important;
}


#texto {
    white-space: normal;
    overflow-wrap: break-word;

}

.title-card-style {
    padding: 1.5px !important;
    max-height: auto;
}

.card-title-text {
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 1em;
    color: white;
}

.collapsable-container {
    background-color: white;
    height: auto !important;
}

.cellT {
    width: 11%;
}
</style>
<style>
.markedrow {
    font-weight: bold !important;
    text-align: center !important;
}

.checkedEl {
    color: #34B7F1 !important;
}
</style>